import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FloatingParticles, WavePattern } from './DecorativeElements';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: "Working with Team FullStack has been a game-changer for our business. Their IT solutions streamlined our operations, resulting in significant cost savings. Their team's expertise and dedication to our success are truly commendable.",
      author: "Rahul Singh",
      company: "Raunak Group",
    },
    {
      text: "Team FullStack's web development expertise took our online presence to a whole new level. They understood our vision and delivered a website that not only looks amazing but also functions seamlessly. Their professionalism and responsiveness made the entire process a breeze.",
      author: "Sunita Mukherjee",
      company: "Incred Research",
    },
    {
      text: "Team FullStack's cybersecurity measures have provided us with a level of protection we didn't know was possible. Their proactive approach to identifying and mitigating potential threats has given us peace of mind. Their team is top-notch in the field.",
      author: "Rohit Saraf",
      company: "Axis Bank",
    },
    {
      text: "We partnered with Team FullStack for their SEO services, and the results were outstanding. Our online visibility and organic traffic saw a remarkable increase. Their strategies are not only effective but also adaptable to our changing needs. I highly recommend their SEO expertise.",
      author: "Neha Kashyap",
      company: "Kotak Mahindra Bank",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonials-section" ref={ref}>
      <FloatingParticles />
      <WavePattern />
      <div className="container">
        <motion.h2
          className="section-title-testimonials"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          Hear from our partners
        </motion.h2>

        <div className="testimonials-wrapper">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              className="testimonial-card"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            >
              <div className="testimonial-quote">"</div>
              <p className="testimonial-text">{testimonials[currentIndex].text}</p>
              <div className="testimonial-author">
                <h4>{testimonials[currentIndex].author}</h4>
                <span>{testimonials[currentIndex].company}</span>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="testimonial-controls">
            <button onClick={prevTestimonial} className="testimonial-btn">
              <ChevronLeft size={24} />
            </button>
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
            <button onClick={nextTestimonial} className="testimonial-btn">
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
